import { render, staticRenderFns } from "./RatingGroups.vue?vue&type=template&id=1dbc8ad5"
import script from "./RatingGroups.vue?vue&type=script&lang=js"
export * from "./RatingGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports